<script lang="ts" setup>
export interface Props {
  product: {
    sku: string
    name: string
  }
}
const props = defineProps<Props>()
const { wishlist, toggleWishlist } = useWishlist()
const { show: showNotification } = useNotification()
const { t: $t } = useI18n()
const isInWishlist = computed(() => wishlist.value.find(item => item.sku === props.product.sku))

const label = computed(() => {
  return isInWishlist.value
    ? $t('Remove from Wishlist')
    : $t('Add to Wishlist')
})

const handleWishlistToggle = (isCurrentlyInWishlist: boolean) => {
  toggleWishlist(props.product.sku)

  if (isCurrentlyInWishlist) {
    showNotification({
      type: 'info',
      message: String($t('{name} has been removed from your wishlist.', { name: props.product.name })),
    })
  }
  else {
    showNotification({
      type: 'success',
      message: String($t('{name} has been added to your wishlist.', { name: props.product.name })),
    })
  }
}
</script>

<template>
  <button
    class="wishlist-toggle"
    @click="handleWishlistToggle(!!isInWishlist)"
  >
    <span class="wishlist-toggle__label">{{ label }}</span>
    <NuxtIcon
      name="icon:heart-empty"
      class="wishlist-toggle__icon"
    />
    <NuxtIcon
      v-show="isInWishlist"
      name="icon:heart-filled"
      class="wishlist-toggle__icon wishlist-toggle__icon--active"
      :filled="true"
    />
  </button>
</template>

<style>
@import url("~layers/components/Product/ToggleWishlist.css");
</style>
